import { CustomerAddress } from '../../../../types/customers';
import i18n from 'i18next';
import { getPostalCodeValidator } from '../../../../helpers/validation/postalCode';

interface FormikErrors {
    [id: string]: string;
}

const addressValidations = (values: CustomerAddress) => {
    const errors: FormikErrors = {};

    if (!values.address_line) {
        errors.address_line = i18n.t('customers.customer.addresses.form.validations.address_line');
    }

    if (!values.postal_place) {
        errors.postal_place = i18n.t('customers.customer.addresses.form.validations.postal_place');
    }

    if (values.postal_code) {
        const { country } = values;
        const postalCodeValidator = getPostalCodeValidator(country, i18n.t('customers.customer.addresses.form.validations.postal_code'));
        const postalCodeError = postalCodeValidator(values.postal_code);
        if (postalCodeError) {
            console.log('postalCodeError', postalCodeError);
            errors.postal_code = postalCodeError;
        }
    }

    return errors;
};

export default addressValidations;
